import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import type { ReportStoreItem } from 'services/interfaces/storeGroupReport';
import { formatCurrency, formatPercent } from './reportFormat';

interface ReportStoresRankingTableProps {
  data: ReportStoreItem[];
}

// Uma linha por loja do grupo — mesmo recorte do store-ranking do ionic. O select de loja
// não se aplica aqui: o ranking compara as lojas entre si.
const ReportStoresRankingTable: React.FC<ReportStoresRankingTableProps> = ({
  data,
}) => {
  const rows = data.filter((row) => row.idi);

  if (rows.length === 0) {
    return (
      <Text color="gray.500" py="2rem" textAlign="center">
        Nenhuma loja do grupo movimentou cashback nesse período.
      </Text>
    );
  }

  return (
    <TableContainer>
      <Table size="sm">
        <Thead>
          <Tr>
            <Th>Loja</Th>
            <Th isNumeric>Gerado</Th>
            <Th isNumeric>Resgatado</Th>
            <Th isNumeric>Taxa</Th>
            <Th isNumeric>Clientes</Th>
          </Tr>
        </Thead>
        <Tbody>
          {rows.map((row) => (
            <Tr key={row.idi}>
              <Td>{row.name || `Loja ${row.idi}`}</Td>
              <Td isNumeric>{formatCurrency(row.generated)}</Td>
              <Td isNumeric>{formatCurrency(row.redeemed)}</Td>
              <Td isNumeric>{formatPercent(row.redeemed, row.generated)}</Td>
              <Td isNumeric>{row.clients}</Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </TableContainer>
  );
};

export default ReportStoresRankingTable;
